import { useState } from 'react';

export default function Testimonial() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: '建設会社 N社長',
      role: '建設会社1次下請',
      image: 'https://public.readdy.ai/ai/img_res/7253b68d912261661a0000e3775353c7.jpg',
      text: '以前は書類作成に毎月20時間以上かかっていましたが、ARISEリーガルオフィスに依頼してから、その時間をゼロにできました。グリーンサイトへの登録もスムーズで、現場の安全管理に集中できるようになりました。'
    }
  ];

  return (
    <section className="py-16 sm:py-24 bg-[#f9f7f4]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 items-center">
          {/* Left Image */}
          <div className="lg:col-span-2">
            <div className="rounded-[32px] overflow-hidden h-[400px] sm:h-[500px] lg:h-[600px]">
              <img 
                src={testimonials[currentIndex].image}
                alt="お客様"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right Content */}
          <div className="lg:col-span-3">
            <div className="text-xs sm:text-sm text-gray-500 mb-3 sm:mb-4">
              (お客様の声)
            </div>
            
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-2 leading-tight">
              <span className="text-[#1a2332]">書類作成の負担が</span>
            </h2>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-8 sm:mb-12 leading-tight">
              <span className="text-gray-400">大幅に軽減されました</span>
            </h2>

            <blockquote className="text-base sm:text-lg text-gray-700 leading-relaxed mb-6 sm:mb-8">
              「{testimonials[currentIndex].text}」
            </blockquote>

            <div className="flex items-center gap-2 mb-6 sm:mb-8">
              <span className="text-base sm:text-lg font-bold text-[#1a2332]">
                — {testimonials[currentIndex].name} ({testimonials[currentIndex].role})
              </span>
            </div>

            <div className="flex items-center gap-4">
              <button 
                className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border-2 border-gray-300 flex items-center justify-center text-gray-400 hover:border-[#1a2332] hover:text-[#1a2332] transition-all cursor-pointer"
                onClick={() => setCurrentIndex(Math.max(0, currentIndex - 1))}
                disabled={currentIndex === 0}
              >
                <i className="ri-arrow-left-line text-lg sm:text-xl"></i>
              </button>
              <button 
                className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#1a2332] flex items-center justify-center text-white hover:bg-[#2a3342] transition-all cursor-pointer"
                onClick={() => setCurrentIndex(Math.min(testimonials.length - 1, currentIndex + 1))}
                disabled={currentIndex === testimonials.length - 1}
              >
                <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
